import React from 'react';
import styled from 'styled-components';

const Message = styled.div`&&&{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.3);
  padding: 60px 0;

  i {
    display: inline-block;
    vertical-align: middle;
    font-size: 30px;
    padding-bottom: 1px;
  }
}`;
export default function Styled({ children, ...props }) {
  return <Message {...props}>{children}</Message>;
}



// WEBPACK FOOTER //
// ./src/components/NullMessage/style.js